import React from "react";
import "./priceDetailModal.css";

const PriceDetailModal = ({ propertyData, onClick }) => {
  const Row = ({ label, value }) => {
    const empty = value === undefined || value === null || value === "";
    return (
      <div className="pdm-row">
        <span className="pdm-row__label">{label}</span>
        <span className={`pdm-row__value${empty ? " pdm-row__value--empty" : ""}`}>
          {empty ? "N/A" : value}
        </span>
      </div>
    );
  };

  return (
    <div className="pdm-overlay" onClick={onClick}>
      <div className="pdm-modal" onClick={(e) => e.stopPropagation()}>
        
        {/* Header */}
        <div className="pdm-header">
          <div className="pdm-header__left">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/>
              <path d="M12 6v6l4 2"/>
            </svg>
            <span className="pdm-title">Price Details</span>
          </div>
          <button className="pdm-close-x" onClick={onClick} aria-label="Close">
            ✕
          </button>
        </div>

        {/* Body */}
        <div className="pdm-body">
          
          {/* Section: Base Pricing */}
          <div className="pdm-section">
            <div className="pdm-section__title">
              <span className="pdm-section__dot" />
              Base Pricing
            </div>
            <div className="pdm-grid">
              <Row 
                label="Base Selling Price" 
                value={propertyData?.base_selling_price} 
              />
              <Row 
                label="Base Price / sq.ft" 
                value={propertyData?.base_selling_price_persqft} 
              />
            </div>
          </div>

          {/* Section: Additional Charges */}
          <div className="pdm-section">
            <div className="pdm-section__title">
              <span className="pdm-section__dot" />
              Additional Charges
            </div>
            <div className="pdm-grid">
              <Row 
                label="Additional Charges" 
                value={propertyData?.additional_charges} 
              />
              <Row 
                label="Additional / sq.ft" 
                value={propertyData?.additional_charges_persqft} 
              />
            </div>
          </div>

          {/* Section: Location Charges */}
          <div className="pdm-section">
            <div className="pdm-section__title">
              <span className="pdm-section__dot" />
              Location Charges
            </div>
            <div className="pdm-grid">
              <Row 
                label="Preferred Location" 
                value={propertyData?.preferred_location_charges} 
              />
              <Row 
                label="Location / sq.ft" 
                value={propertyData?.preferred_location_charges_persqft} 
              />
            </div>
          </div>

          {/* Section: Unit Info */}
          <div className="pdm-section">
            <div className="pdm-section__title">
              <span className="pdm-section__dot" />
              Unit Information
            </div>
            <Row 
              label="Unit Area" 
              value={
                propertyData?.unit_area
                  ? `${propertyData.unit_area} ${propertyData.unit_area_measure_in || ""}`
                  : null
              } 
            />
          </div>

        </div>

        {/* Footer */}
        <div className="pdm-footer">
          <button className="pdm-btn pdm-btn--primary" onClick={onClick}>
            Close
          </button>
        </div>

      </div>
    </div>
  );
};

export default PriceDetailModal;